import { useReadNotificationMutation } from '@/graphql';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Dialog, Typography, Button } from '@material-ui/core';
import SmallLogoIcon from '@/components/icons/small-logo';
import { useNavigate } from 'react-router-dom';
import { useModalSlot } from '@/contexts/modal-coordinator-context';
import { ModalSlotId } from '@/type';

interface PremiumExpiredProps {
  premiumExpiredNotificationId?: string;
}

const PremiumExpiredModal: React.FC<PremiumExpiredProps> = ({ premiumExpiredNotificationId }) => {
  const [readNotification] = useReadNotificationMutation({ context: { errorHandling: 'notify' } });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [opened, setOpened] = useState(true);
  const { isActive } = useModalSlot(ModalSlotId.PremiumExpired, opened);

  const onClose = () => {
    if (premiumExpiredNotificationId) {
      readNotification({
        variables: { id: premiumExpiredNotificationId },
      }).catch(() => {});
      setOpened(false);
    }
  };

  return (
    <Dialog data-cy-premium-is-expired-dialog open={isActive && opened} onClose={onClose}>
      <Box display="flex" flexDirection="column" p={6} pt={5}>
        <Box marginBottom={4}>
          <SmallLogoIcon />
        </Box>
        <Typography variant="h2">{t('dialogs.premium-expired.title')}</Typography>
        <Box marginTop={3}>
          <Typography variant="body2">{t('dialogs.premium-expired.text')}</Typography>
        </Box>
        <Box mt={7} display="flex" flexDirection="column">
          <Button
            onClick={() => {
              onClose();
              navigate('/subscription');
            }}
            variant="contained"
            color="primary"
          >
            {t('dialogs.premium-expired.btn')}
          </Button>
          <Button variant="outlined" style={{ color: '#2B75B3', marginTop: 16 }} onClick={onClose}>
            {t('common.later')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PremiumExpiredModal;
